import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type StaffRoleFragment = { id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null };


export type StaffRoleFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const StaffRoleFragmentDoc = /*#__PURE__*/ gql`
    fragment StaffRole on RoleType {
  id
  name
  description
  type
  metadata {
    tagColor
    configuredPermissions
  }
}
    `;